export default "__VITE_ASSET__f02a85cd__"